<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">


                <div class="admin_main_block_left">
                    <div><router-link to="/Admin/xideshuoshisqsp/form"><el-button type="primary" icon="el-icon-plus">添加</el-button></router-link></div>

                    <div style="width:140px;">
                        <el-select v-model="where.shisqlx" filterable placeholder="请选择分类" @change="selectChange()">
                            <el-option label="请选择分类" :value="0"></el-option>
                            <el-option v-for="(v,k) in list['shisq']" :label="v.shisqlx" :key="k" :value="v.id"></el-option>
                        </el-select>
                    </div>

                    <div><el-button icon="el-icon-search" @click="get_adv_list()">条件筛选</el-button></div>
                    <div>
                        <el-button icon="el-icon-refresh-right" @click="reloads()">重置</el-button>
                    </div>
                </div>


                <div class="admin_main_block_right">
                    <div><el-button type="danger" icon="el-icon-delete" @click="del(select_id)">批量删除</el-button></div>
                </div>
            </div>
            <div class="admin_table_main">
                <el-table :data="info" @selection-change="handleSelectionChange" >
                    <el-table-column type="selection"></el-table-column>
                    <!-- <el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column> -->
                    <el-table-column prop="id" label="#"  width="100px"></el-table-column>

                    <el-table-column prop="shisqlxmc" label="师生圈类型"  width="500px"></el-table-column>

                    <el-table-column label="视频" width="200px">
                        <template slot-scope="scope">
                            <video-player
                                    ref="videoPlayer" :playsinline="true"  :options="playerOptionss[scope.$index]">
                            </video-player>
                        </template>
                    </el-table-column>





                    <el-table-column prop="createtime" label="创建时间">
                        <template slot-scope="scope">
                            <div v-if="scope.row.createtime<=0"> - </div>
                            <div v-else>{{scope.row.createtime|formatDate}}</div>
                        </template>
                    </el-table-column>



                   <!-- <el-table-column label="操作" fixed="right" width="120px">
                        <template slot-scope="scope">
                            &lt;!&ndash;<el-button icon="el-icon-edit" :disabled="scope.row.F_TI_STATUS==2 || scope.row.F_TI_STATUS==3" @click="verify_click(scope.row.F_IN_ID)">审核</el-button>&ndash;&gt;
                            <el-button icon="el-icon-edit"  @click="verify_click(scope.row.F_IN_ID)">审核</el-button>
                            &lt;!&ndash; <el-button type="danger" icon="el-icon-delete" @click="del(scope.row.id)">删除</el-button> &ndash;&gt;
                        </template>
                    </el-table-column>-->
                    <!--<el-table-column label="操作" fixed="right" width="120px">
                        <template slot-scope="scope">
                            <el-button icon="el-icon-edit" @click="$router.push({name:'adv_form',params:{id:scope.row.id}})">编辑</el-button>
                            &lt;!&ndash; <el-button type="danger" icon="el-icon-delete" @click="del(scope.row.id)">删除</el-button> &ndash;&gt;
                        </template>
                    </el-table-column>-->
                </el-table>
                <div class="admin_table_main_pagination">
                    <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { videoPlayer } from 'vue-video-player';
    import 'video.js/dist/video-js.css'
    export default {
        name: "TestTwo",
        components: {videoPlayer},
        computed:{
            player(){
                return this.$refs.videoPlayer.player
            }
        },
        props: {},
        data() {
            return {
                list:[],
                total_data:0, // 总条数
                page_size:20,
                current_page:1,
                select_id:'',
                adv_position_id:0,
                where:{

                },
                playerOptions:{
                    //播放速度
                    playbackRates:[0.5,1.0,1.5,2.0],
                    //如果true,浏览器准备好时开始回放.
                    autoplay:false,
                    //默认情况下将会消除任何音频
                    muted:false,
                    //导致视频一结束就重新开始
                    loop:false,
                    //建议浏览器在<video>加载元素后是否应该开始下载视频
                    preload:'auto',
                    language:'zh-CN',
                    aspectRatio:'16:9',
                    fluid:true,
                    sources:[{
                        //类型
                        type:"video/mp4",
                        //url地址
                        src:'http://wechat.cloudliveshop.com/Uploads/upload/1610248596.mp4'
                    }],
                    poster:'',
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息
                    notSupportedMessage:'此视频暂无法播放，请稍后再试',
                    controlBar:{
                        timeDivider:true,
                        durationDisplay:true,
                        remainingTimeDisplay:false,
                        //全屏按钮
                        fullscreenToggler:true
                    }
                },
                playerOptionss:[],
                info:[],
            };
        },
        watch: {},

        methods: {
            reloads:function(){
                this.where={};
                this.get_adv_list();
            },
            handleSelectionChange:function(e){
                let ids = [];
                e.forEach(v => {
                    ids.push(v.id);
                });
                this.select_id = ids.join(',');
            },
            get_adv_list:function(){
                let where = {};
                where.page = this.current_page;
                where.params = this.where;
                this.$get(this.$api.getShisqspList,where).then(res=>{
                    this.page_size = res.data.info.per_page;
                    this.total_data = res.data.info.total;
                    this.current_page = res.data.info.current_page;
                    this.info = res.data.info.data;
                    this.list = res.data;

                    // 遍历数组B，以id的值作为数组的key，name的值作为数组的value,存放到临时数组arrayC
                    for(let i = 0; i < res.data.info.data.length; i ++) {
                        // 为arrayC添加名称为arrayB[i].id的属性字段，值等于arrayB[i].name
                        console.log('取值')
                        console.log(res.data.info.data[i].shipurl)
                        console.log('取值')

                        let arrStr = {
                            //播放速度
                            playbackRates:[0.5,1.0,1.5,2.0],
                            //如果true,浏览器准备好时开始回放.
                            autoplay:false,
                            //默认情况下将会消除任何音频
                            muted:false,
                            //导致视频一结束就重新开始
                            loop:false,
                            //建议浏览器在<video>加载元素后是否应该开始下载视频
                            preload:'auto',
                            language:'zh-CN',
                            aspectRatio:'16:9',
                            fluid:true,
                            sources:[{
                                //类型
                                type:"video/mp4",
                                //url地址
                                src:res.data.info.data[i].shipurl
                            }],
                            poster:'',
                            //允许覆盖Video.js无法播放媒体源时显示的默认信息
                            notSupportedMessage:'此视频暂无法播放，请稍后再试',
                            controlBar:{
                                timeDivider:true,
                                durationDisplay:true,
                                remainingTimeDisplay:false,
                                //全屏按钮
                                fullscreenToggler:true
                            }
                        }

                        this.playerOptionss.push(arrStr)

                    }



                })

                //this.playerOptions['sources'][0]['src'] = 'http://wechat.cloudliveshop.com/Uploads/upload/1610248596.mp4';
                //this.$refs.video.src = 'http://wechat.cloudliveshop.com/Uploads/upload/1610248596.mp4';
            },
            // 删除处理
            del:function(F_IN_ID){
                if(this.$isEmpty(F_IN_ID)){
                    return this.$message.error('请先选择删除的对象');
                }
                this.$post(this.$api.delDuansplb,{F_IN_ID:F_IN_ID}).then(res=>{
                    if(res.code == 200){
                        this.get_adv_list();
                        return this.$message.success("删除成功");
                    }else{
                        return this.$message.error("删除失败");
                    }
                });
            },
            current_change:function(e){
                this.current_page = e;
                this.get_adv_list();
            },
            verify_click:function(F_IN_ID){
                this.$confirm('此操作将控制是否通过审核, 是否继续?', '提示', {
                    confirmButtonText: '同意',
                    cancelButtonText: '拒绝',
                    type: 'info'
                }).then(() => {
                    this.$post(this.$api.duansplbChange,{F_IN_ID:F_IN_ID,F_TI_STATUS:2}).then(()=>{
                        this.$message.success('成功审核');
                        this.get_adv_list();
                    });

                }).catch(() => {
                    this.$post(this.$api.duansplbChange,{F_IN_ID:F_IN_ID,F_TI_STATUS:3}).then(()=>{
                        this.$message.info('已拒绝');
                        this.get_adv_list();
                    });

                });
            },
        },
        created() {

            this.get_adv_list();
        },
        mounted() {}
    };
</script>
<style lang="scss" scoped>
</style>
